import styled from 'styled-components';

export const containerNotAuthorized = styled.div`
	padding: 1rem;
`;
